import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Google Play reviews. Two entry points:
//  - auto=true: the server decided this is a good moment (see
//    Courses::ReviewPrompt); ask the shell to show the in-app review card,
//    then report it (recordUrl) so the cooldown starts. Builds without the
//    review bridge never load this controller, so they never report.
//    Play may silently skip the card (quota), which is fine — never add UI around it.
//  - openStore(): an explicit "Rate the app" tap; opens the store listing on
//    the reviews tab. Outside the app the click falls through to the href.
export default class extends BridgeComponent {
  static component = "review"
  static values = { auto: Boolean, recordUrl: String }

  connect() {
    super.connect()
    if (!this.autoValue) return

    this.send("request")
    this.record()
  }

  openStore(event) {
    if (!this.enabled) return

    event.preventDefault()
    this.send("store")
  }

  record() {
    if (!this.recordUrlValue) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.recordUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": csrfToken },
      keepalive: true,
    }).catch(() => {})
  }
}
